@if (layout.sidebarMovilAbierto()) {
  <!-- Fondo del cajón: solo existe mientras el menú tapa el contenido -->
  <div
    class="fixed inset-0 z-30 bg-black/50 lg:hidden"
    (click)="layout.cerrarSidebarMovil()"
    aria-hidden="true"
  ></div>
}

<!--
  Hasta `lg` el menú es un cajón fijo que entra desde la izquierda; de ahí para
  arriba vuelve al flujo como columna y puede colapsarse a rail de iconos.
-->
<aside
  class="fixed inset-y-0 left-0 z-40 flex h-dvh w-sidebar shrink-0 flex-col border-r border-gray-200 bg-white text-sm shadow-xl transition-transform duration-200 lg:relative lg:z-auto lg:translate-x-0 lg:shadow-none lg:transition-[width] dark:border-gray-800 dark:bg-gray-900"
  [class]="clasesAside()"
>
  <!-- Botón de colapso (el cajón móvil no se colapsa: se cierra) -->
  <button
    type="button"
    (click)="layout.toggleSidebar()"
    class="absolute top-7 -right-3 z-10 hidden size-6 cursor-pointer items-center justify-center rounded-full bg-white text-gray-500 shadow-md ring-1 ring-gray-200 transition-colors hover:bg-primary-600 hover:text-white lg:flex dark:bg-gray-800 dark:text-gray-300 dark:ring-gray-700"
    [attr.aria-label]="layout.sidebarCompacto() ? 'Expandir menú' : 'Colapsar menú'"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
      class="size-3.5 transition-transform duration-200"
      [class.rotate-180]="layout.sidebarCompacto()">
      <path d="m15 18-6-6 6-6" />
    </svg>
  </button>

  <!-- Marca -->
  <div class="flex items-center gap-3 px-5 py-5" [class.justify-center]="layout.sidebarCompacto()"
    [class.px-0]="layout.sidebarCompacto()">
    <div class="flex size-9 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white ring-1 ring-gray-200 dark:ring-gray-700">
      <img src="/logo-ihimv.png" alt="IHIMV — SENASA" class="size-full object-contain" />
    </div>
    @if (!layout.sidebarCompacto()) {
      <div class="leading-tight">
        <p class="font-bold text-gray-900 dark:text-white">SiLabVet</p>
        <p class="text-[10px] font-semibold tracking-[0.15em] text-gray-400 uppercase">Senasa</p>
      </div>
    }
    <span class="flex-1 lg:hidden"></span>
    <button
      type="button"
      (click)="layout.cerrarSidebarMovil()"
      class="-mr-1 flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-lg text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700 lg:hidden dark:hover:bg-gray-800 dark:hover:text-gray-200"
      aria-label="Cerrar menú"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
        <path d="M18 6 6 18M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Perfil de usuario -->
  @if (!layout.sidebarCompacto()) {
    <div class="relative mx-3 mb-2 overflow-hidden rounded-xl bg-gradient-to-br from-primary-50 to-primary-100/60 p-4 dark:from-primary-950 dark:to-gray-800">
      <button
        type="button"
        (click)="layout.perfilAbierto.set(true)"
        class="absolute top-3 right-3 cursor-pointer text-gray-400 transition-colors hover:text-primary-600 dark:text-gray-500 dark:hover:text-primary-300"
        aria-label="Configuración de perfil"
        title="Ver perfil"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5">
          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      </button>
      <div class="flex size-11 items-center justify-center rounded-full bg-primary-600 text-sm font-bold text-white shadow-sm">
        {{ iniciales() }}
      </div>
      <p class="mt-2.5 font-bold text-gray-900 dark:text-white">{{ nombre() }}</p>
      <p class="text-xs text-gray-500 dark:text-gray-400">{{ rol() }}</p>
    </div>
  } @else {
    <div class="mb-2 flex justify-center">
      <div class="flex size-10 items-center justify-center rounded-full bg-primary-600 text-xs font-bold text-white shadow-sm">
        {{ iniciales() }}
      </div>
    </div>
  }

  <!-- Navegación -->
  <nav class="flex-1 overflow-y-auto px-3 py-2">
    <ul class="space-y-1">
      @for (seccion of secciones(); track seccion.label) {
        <li>
          @if (esDirecta(seccion)) {
            <!-- Una sola opción: se enlaza directo, sin un nivel que no aporta -->
            <a
              [routerLink]="seccion.items[0].route"
              routerLinkActive="!bg-primary-50 !text-primary-600 dark:!bg-primary-950 dark:!text-primary-300"
              [title]="seccion.items[0].label"
              class="flex items-center gap-3 rounded-lg px-3 py-2.5 font-medium text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
              [class.justify-center]="layout.sidebarCompacto()"
            >
              <app-nav-icon [icon]="seccion.icon" />
              @if (!layout.sidebarCompacto()) {
                <span>{{ seccion.items[0].label }}</span>
              }
            </a>
          } @else if (layout.sidebarCompacto()) {
            <!--
              Rail de iconos: no hay dónde desplegar, así que cada opción se
              dibuja suelta con su propio icono.
            -->
            <ul class="space-y-1">
              @for (item of seccion.items; track item.route) {
                <li>
                  <a
                    [routerLink]="item.route"
                    routerLinkActive="!bg-primary-50 !text-primary-600 dark:!bg-primary-950 dark:!text-primary-300"
                    [title]="item.label"
                    class="flex items-center justify-center rounded-lg px-3 py-2.5 font-medium text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
                  >
                    <app-nav-icon [icon]="item.icon" />
                  </a>
                </li>
              }
            </ul>
          } @else {
            <!-- Sección plegable: el icono y el nombre son la fila que se pulsa -->
            <button
              type="button"
              (click)="alternarSeccion(seccion.label)"
              class="flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 text-left font-medium transition-colors hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-800 dark:hover:text-white"
              [class]="seccionActiva(seccion) ? 'text-primary-600 dark:text-primary-300' : 'text-gray-600 dark:text-gray-400'"
              [attr.aria-expanded]="abierta(seccion.label)"
            >
              <app-nav-icon [icon]="seccion.icon" />
              <span class="flex-1 leading-snug">{{ seccion.label }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                class="size-3.5 shrink-0 text-gray-400 transition-transform duration-200 dark:text-gray-500"
                [class.rotate-90]="abierta(seccion.label)">
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>
            @if (abierta(seccion.label)) {
              <!-- Las opciones cuelgan del padre: indentadas y sin icono propio -->
              <ul class="mt-1 ml-5 space-y-0.5 border-l border-gray-200 pl-3 dark:border-gray-700">
                @for (item of seccion.items; track item.route) {
                  <li>
                    <a
                      [routerLink]="item.route"
                      routerLinkActive="!font-semibold !text-primary-600 dark:!text-primary-300"
                      [title]="item.label"
                      class="block rounded-lg px-3 py-2 text-[13px] text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
                    >
                      {{ item.label }}
                    </a>
                  </li>
                }
              </ul>
            }
          }
        </li>
      }
    </ul>
  </nav>

  <!--
    Versión desplegada: lo primero que se pide al reportar un problema. En el
    rail de iconos no cabe el texto, así que solo se muestra expandido.
  -->
  @if (!layout.sidebarCompacto()) {
    <div class="border-t border-gray-200 px-5 py-3 dark:border-gray-800">
      <p class="truncate text-[11px] text-gray-400 dark:text-gray-500" [title]="version()">
        Versión {{ version() }}
      </p>
    </div>
  }
</aside>
